import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";

const MEDIA = [
  { name: "La Vanguardia", className: "font-serif italic text-xl md:text-2xl lg:text-3xl text-charcoal" },
  { name: "RAC1", className: "font-sans font-bold text-lg md:text-xl lg:text-2xl tracking-tight text-charcoal" },
  { name: "Primera Persona", className: "font-serif text-xl md:text-2xl lg:text-3xl text-charcoal" },
];

/**
 * PressBar
 * "As seen in" media bar - visible social proof for the home hero.
 * Each logo links to /prensa.
 */
const PressBar = () => {
  const t = useT();
  return (
  <div className="mt-14 md:mt-16" data-testid="press-bar">
    <div className="flex items-center gap-4 mb-5">
      <span className="h-px flex-1 max-w-[60px] bg-charcoal/20" />
      <span className="text-[10px] tracking-[0.36em] uppercase text-charcoal/55">
        {t("home.hero.pressEyebrow")}
      </span>
      <span className="h-px flex-1 bg-charcoal/20" />
    </div>
    <Link
      to="/prensa"
      data-testid="press-bar-link"
      className="block group"
      aria-label="Ver todas las apariciones en medios"
    >
      <div className="flex flex-wrap items-center justify-start gap-x-10 md:gap-x-14 gap-y-4">
        {MEDIA.map((m, i) => (
          <span
            key={m.name}
            className={`${m.className} opacity-80 group-hover:opacity-100 transition-opacity duration-300`}
            style={{ transitionDelay: `${i * 40}ms` }}
          >
            {m.name}
          </span>
        ))}
      </div>
    </Link>
  </div>
  );
};

export default PressBar;
